import { InjectionToken } from '@angular/core';

export const FAYE_CLIENT = new InjectionToken<any>('FAYE_CLIENT_TOKEN');
